// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { bindActionCreators } from "redux";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import { IProject, IAuthenticationState, IApplicationState, IConnection, IAzureFields } from "../../../../models/applicationState";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import OperationsHeader from "../header/operationsSubHeader";
import axios from "axios";
import { headers, postProcessingXMLPathURL } from "../../../../common/api-config";

export interface IPostProcessingProps extends RouteComponentProps, React.Props<PostProcessing> {
    userModelActions: IUserModelActions;
    loggedInUser: IAuthenticationState;
    userOperationsActions: IUserOperationsActions;
    filesUploadingAction: IFilesUploadingAction;
    actions: IProjectActions;
    project: IProject;
    recentProjects: IProject[];
    path: object;
    projectActions: IProjectActions;
    userModels: any;
}

export interface IPostProcessingState {
    userId: string;
    connection: IConnection;
    myModels: any;
    loadModal: boolean;
    showDate: boolean;
    allData: any;
    loaderText: string;
    loadingProjects: boolean;
    selectedFilter: any;
    invoiceWithOrwithoutPO: String;
    selectedRecords: any;
    fromDate: any;
    toDate: any;
    loadProcess: boolean;
    searchText: string;
}

function mapDispatchToProps(dispatch) {
    return {
        userModelActions: bindActionCreators(userModelActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
        filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
        actions: bindActionCreators(projectActions, dispatch),
    };
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class PostProcessing

    extends React.Component<IPostProcessingProps, IPostProcessingState> {

    public state: IPostProcessingState = {
        userId: null,
        connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
        myModels: [],
        loadModal: false,
        showDate: false,
        loadProcess: false,
        allData: [],
        loaderText: "Loading file to preview",
        loadingProjects: false,
        selectedFilter: '',
        invoiceWithOrwithoutPO: '',
        selectedRecords: [],
        fromDate: '',
        toDate: '',
        searchText: ''
    };
    records = [];
    constructor(props) {
        super(props);

    }

    public async componentDidMount() {
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        await this.setState({ loadModal: false, userId });
        localStorage.removeItem("lastVisttedtestAssetId");
        localStorage.removeItem("filesLength");
        localStorage.removeItem("testFilesLengthFromTest");
        localStorage.removeItem("filesLengthFromModel");
        // this.setState({ loadModal: true });
        // const modelData = await this.props.userOperationsActions.invoiceManagement();
        // this.setState({ loadModal: false, myModels: modelData, allData: modelData });

    }

    public tableDataShow = () => {
        const { myModels } = this.state;
        return (
            <div>
                {myModels && size(myModels) > 0 ?
                    <div className="card wrap-body-my_models shadow model-data mt-2">
                        <table className="table table-dark table-striped">
                            <thead>
                                <tr>
                                    {/* <th style={{ width: '50px' }}><input type="checkbox" onClick={this.handleClick.bind(this)} /></th> */}
                                    <th style={{ width: "1000px", tableLayout: "fixed" }} >File Name</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>Company Name</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>Vendor Name</th>
                                    <th style={{ width: "600px", tableLayout: "fixed" }}>Vendor Invoice No.</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>PO No.</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>IR No.</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>Invoice Date</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>PR No.</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>Status</th>
                                    <th style={{ width: "500px", tableLayout: "fixed" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {myModels && myModels.map((model, index) => {
                                    return (
                                        <tr key={index}>
                                            {/* <td><input type="checkbox" onClick={() => this.handleSingleCheck(model)} /></td> */}
                                            <td>{model.Filename}</td>
                                            <td>
                                                Ace Square
                                                {/* {model.companyName} */}
                                            </td>


                                            <td>
                                                ALS Carpet
                                               {/* {model.vendorName} */}
                                            </td>
                                            <td>
                                                {model.Vendor_Invoice_Number}
                                            </td>
                                            <td>
                                                {model.po_number}
                                            </td>
                                            <td>
                                                {model.invoice_receipt_number}
                                            </td>
                                            <td>{model.invoice_date}</td>
                                            <td>{model.PR_number}</td>
                                            <td>{model.Status_Error_msgs}</td>
                                            <td className="action-control">
                                                <button role="button" className="view"
                                                    onClick={() => this.goToModel(model)}>
                                                    <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    : <p className="text-center">No Data Available</p>}
            </div>
        );
    }


    public render() {
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <LoadingOverlay
                    active={this.state.loadingProjects}
                    spinner
                    className={this.state.loadingProjects ? "wrap-queue-height" : ""}
                    text={this.state.loaderText}
                >
                    <OperationsHeader propsMatch={this.props.match} />

                    <div className="container-fluid animated fadeIn">
                        <div className="row mt-2">
                            <div className="col-md-7">
                                <div className="input-group input-group-sm my-model-filter ">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fas fa-search"></i>
                                        </span>
                                    </div>
                                    <input type="text" placeholder="search with xml path" onChange={(e) => this.searchSpace(e)} className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-3">
                            </div>
                            <div className="col-md-2">
                                {/* <button className="btn-custom float-right" onClick={() => this.updateModels(true)}>
                                    <i className="fas fa-sync-alt"></i> Refresh </button> */}
                            </div>
                        </div>
                      {
                          this.state.loadModal?<Spinner
                          size={SpinnerSize.small}
                          label="Loading Tags"
                          ariaLive="off"
                          labelPosition="bottom"
                      />:<div></div>
                      }

                    </div>

                </LoadingOverlay>
            </>
        );
    }
    public searchSpace = (e) => {
        const keyword = e.target.value;
        this.setState({ searchText: keyword });
        if (keyword === "") {
            this.setState({loadModal:false})

            // this.setState({ myModels: this.state.allData });
            // this.tableDataShow();
        } else {
            this.setState({loadModal:true})
            const endpointURL = postProcessingXMLPathURL(keyword);
            axios( endpointURL , { method: "POST", headers }).
            then((resp) => {
              if (resp.status === 200 || resp.status === 201) {
                this.setState({loadModal:false})

                console.log("resp",resp)
                resp.data['path'] = keyword
                localStorage.setItem("selectedFileUrl",JSON.stringify(resp.data));
                this.props.history.push(`/operations/editTagsData_for_PP`);
               
              }
            })
            .catch((error) => {
            });
        
        }
    }
    /**
     * Get Queue Data
     */
    public goToModel = async (model) => {
        localStorage.setItem("selectedFile", JSON.stringify(model));
        this.props.history.push(`/operations/editTagsData`);
    }
    /**
    * get updated models
    */
    private updateModels = async (flag?: boolean) => {
        this.setState({ loadModal: true, selectedFilter: '', loaderText: 'Loading file to preview' });
        const modelData = await this.props.userOperationsActions.invoiceManagement();
        this.setState({ loadModal: false, myModels: modelData, allData: modelData });
    }
}
